/**
 * Business function. make query params function for API call.
 * @returns {function} The makeQueryParams function.
 */
const entitiesRequest = ({ search }) => {
  if (search && search.length > 0)
    return {
      q: {
        $or: [
          { id: { $instr: `${search}` } },
          { name: { $instr: `${search}` } },
          { short_name: { $instr: `${search}` } },
        ],
      },
      limit: 6,
    };

  return null;
};
export default entitiesRequest;
